import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const BaseUrlTitle = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
   fontWeight: 500, 
   margin: theme.spacing(3, 0)
}));

